<div class="d-flex justify-content-around align-items-center">
  <button (click)="onBadReqClick()" mat-button mat-raised-button>Bad Request Simulator</button>
  <button (click)="onNotFoundReqClick()" mat-button mat-raised-button>Not Found Request Simulator</button>
  <button (click)="onUnauthorizedReqClick()" mat-button mat-raised-button>Unauthorized Request Simulator</button>
  <button (click)="onForbiddenReqClick()" mat-button mat-raised-button>Forbidden Request Simulator</button>
  <button (click)="onInternalErrorReqClick()" mat-button mat-raised-button>Internal Server Error Request Simulator
  </button>
</div>
